import React, { useEffect, useRef, memo } from 'react';

function TradingViewWidget({ ticker }) {
  const container = useRef();

  useEffect(
    () => {
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "symbols": [
            [
              "${ticker}",
              "${ticker}|1M"
            ]
          ],
          "chartOnly": false,
          "width": "100%",
          "height": "100%",
          "locale": "en",
          "colorTheme": "dark",
          "autosize": true,
          "showVolume": false,
          "showMA": false,
          "hideDateRanges": false,
          "hideMarketStatus": false,
          "hideSymbolLogo": false,
          "scalePosition": "right",
          "scaleMode": "Normal",
          "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
          "fontSize": "10",
          "noTimeScale": false,
          "valuesTracking": "1",
          "changeMode": "price-and-percent",
          "chartType": "area",
          "maLineColor": "#2E5BFF",
          "maLineWidth": 1,
          "maLength": 9,
          "headerFontSize": "medium",
          "lineWidth": 2,
          "lineType": 0,
          "dateRanges": [
            "1d|1",
            "1m|30",
            "3m|60",
            "12m|1D",
            "60m|1W",
            "all|1M"
          ],
          "lineColor": "rgba(46, 91, 255, 1)",
          "topColor": "rgba(42, 46, 57, 1)",
          "bottomColor": "rgba(42, 46, 57, 1)",
          "gridLineColor": "rgba(42, 46, 57, 0.5)",
          "borderColor": "rgba(42, 46, 57, 1)",
          "backgroundColor": "rgba(42, 46, 57, 1)",
          "textColor": "rgba(255, 255, 255, 1)"
        }`;
      
      const currentContainer = container.current;
      currentContainer.appendChild(script);

      return () => {
        // Cleanup
        if (currentContainer && script.parentNode === currentContainer) {
          currentContainer.removeChild(script);
        }
        // Clear the container content to remove any remaining widget elements
        if (currentContainer) {
          currentContainer.innerHTML = '';
        }
      };
    },
    [ticker]
  );

  return (
    <div className="tradingview-widget-container" ref={container}>
      <div className="tradingview-widget-container__widget"></div>
      <div className="tradingview-widget-copyright"></div>
    </div>
  );
}

export default memo(TradingViewWidget); 